import { Coordinate } from "ol/coordinate";
import { WKT } from "ol/format";
import { toLonLat } from "ol/proj";

export class Barrier {
    uid!: number;
    ente!: number;
    denominazione!: string;
    indirizzo!: string;
    fascicolo!: number;
    comune!: number;
    provincia!: number;
    localita!: string;
    destinazioniUso!: number[];
    wgs84Lat!: string;
    wgs84Lon!: string;
    roma40Lat!: string;
    roma40Lon!: string
    creazione!: string;
    aggiornamento!: string;
    geom!: string;
    codiceSbarramento!: string;
    numeroVersione!: number;
    ultimaVersione!: boolean;
    statoFascicolo!: number;
    titolare!: string;
    categoria!: string;
    tipologia!: string;

    constructor(init?: Partial<Barrier>) {
        Object.assign(this, init);
    }

    checked?: boolean;

    get geomCoord() {
        const wktFormat = new WKT();
        const geometry = wktFormat.readGeometry(this.geom) as any;
        return geometry.getCoordinates()[0].map((x: Coordinate) => toLonLat(x)) as Coordinate;
    }
}

export class BarrierList {
    risultati: Barrier[] = [];

    constructor(items?: Barrier[]) {
        if (items) this.risultati = items;
    }

    get checkedBarriers(): Barrier[] {
        return this.risultati.filter((items) => items.checked);
    }

    get allBarriersChecked(): boolean {
        return this.risultati.length === this.checkedBarriers.length;
    }

    set allBarriersChecked(checked: boolean) {
        this.risultati.forEach((item) => (item.checked = checked));
    }
}
